module.exports = __webpack_public_path__ + "img/table.694ef055.svg";